import { render, staticRenderFns } from "./DeleteStudentSlidebar.vue?vue&type=template&id=4cc35af2"
import script from "./DeleteStudentSlidebar.vue?vue&type=script&lang=js"
export * from "./DeleteStudentSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports